// Matches Backend/Kuika.Designtime.Model/Enums/EAgentToolType.cs
export enum EAgentToolType {
  Mcp = 0,
  CustomTool = 1,
  KAction = 2
}
